import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://supserv.fs.mk/bmp/api';

console.log('Using API URL:', API_URL); // Debug to confirm correct URL

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
